import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const iframeUrl = `${process.env.VUE_APP_MODULEAPP_URL_2}micro/module-app/email-manage/index`;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("iframe", {
        width: "100%",
        class: "micro-app-frame",
        id: "micro-app-email-frame",
        src: iframeUrl
      });
    };
  }
});